import React, { useEffect } from 'react';
import moment from 'moment';
import {
  useParams,
  NavLink,
} from 'react-router-dom';

import meta from '../../config/meta';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';
import Html from '~/commons/components/Html.jsx';

const PageShare = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    req({
      url: `/api/site/shares/${_id}`,
    });
  }, [_id]);

  return (
    <PageHttp res={res}>
      {(doc) => {
        meta.set({ title: doc.title });

        return (
        <div>
            <div className="jumbotron jumbotron-fluid position-relative vh-50 m-0" style={{maxHeight: "250px"}}>
                <div className="img-bg-cover" style={{backgroundImage: "url(/uploads/GkJSq33X2.jpg)"}}></div>
                <div className="pos-abs-center bg-white px-5 py-2">
                    <h1 className="m-0">
                        <div className="small-sm smaller-xs">用家分享</div>
                    </h1>
                </div>
            </div>        
          <div className="py-3 container">

            <div className="readable">
              <div className="row align-items-center">
                <div className="col">
                  <NavLink to="." className="small text-primary">
                    <img
                      src="/assets/img/long-arrow-left.svg"
                      style={{ width: '38px', height: '9px' }}
                    />
                    &nbsp;
                    用家分享
                  </NavLink>
                </div>
              </div>
              <h1 className="h2 mt-3 mb-3 mb-md-4">{doc.title}</h1>
              <Html>{doc.content}</Html>
            </div>
          </div>
        </div>
        );
      }}
    </PageHttp>
  );
};

export default PageShare;
